import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AccountInfo, EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import AntdConfigProvider from 'integrations/antd';
import ReactQueryProvider from 'integrations/react-query';
import { ErrorBoundary } from 'app/atoms';
import { router } from 'routes/router';
import { setupApiInterceptors } from 'utils/axios';
import { msalConfig } from './authConfig';
import 'styles/tailwind.css';

dayjs.extend(utc);

const msalInstance = new PublicClientApplication(msalConfig);

// Top-level await isn't used here for broader build-target compatibility.
async function init() {
  await msalInstance.initialize();

  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const account = event.payload as { account: AccountInfo };
      if ('account' in account) {
        msalInstance.setActiveAccount(account.account);
      }
    }
  });

  setupApiInterceptors();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <ErrorBoundary>
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <AntdConfigProvider>
            <ReactQueryProvider>
              <RouterProvider router={router} />
            </ReactQueryProvider>
          </AntdConfigProvider>
        </MsalProvider>
      </React.StrictMode>
    </ErrorBoundary>,
  );
}

init();
